/**
 * UB-03 (bug-triage plan, Oct 2026) — where the top bar's Help and Contact
 * buttons point. Constants in one place, for the same reason BRAND is: when
 * the support mailbox moves or a WhatsApp line is opened, the change is one
 * line here rather than a sweep.
 */
/**
 * The in-app Help page (`apps/web/src/features/help`). A ROUTE now, not an
 * external address: the top bar's Help button navigates to it and appends the
 * section for the module the person is standing in (`/help#sales`). The
 * placeholder docs URL this replaced opened a page that did not exist.
 */
export const HELP_URL = '/help';
/** The Contact-us `mailto:` target. */
export const SUPPORT_EMAIL = 'support@bosala.dev';
/**
 * The support WhatsApp line, as the international number without `+`, spaces
 * or dashes (`9725XXXXXXXX`), which is what `https://wa.me/<number>` takes.
 * EMPTY MEANS HIDDEN: the Help page draws no WhatsApp button until the owner
 * fills this in.
 */
export const SUPPORT_WHATSAPP = '';
//# sourceMappingURL=support.js.map